import { NgModule } from '@angular/core';
import { Route, RouterModule, Routes, UrlMatchResult, UrlSegment, UrlSegmentGroup } from '@angular/router';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { CardsManagementComponent } from './pages/cards-management/cards-management.component';
import { HomeComponent } from './pages/home/home.component';
import { ImpressumComponent } from './pages/impressum/impressum.component';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { LoginComponent } from './pages/login/login.component';
import { RegisterComponent } from './pages/register/register.component';
import { UnavailableComponent } from './pages/unavailable/unavailable.component';

const routes: Routes = [
  // { path: 'home', component: HomeComponent },
  { path: 'landing-page', component: LandingPageComponent },
  {
    path: '',
    component: HomeComponent,
    children: [
        {
            path: '',
            component: LandingPageComponent
        },
        {
            path: 'login/:type',
            component: LoginComponent
        },
        {
            path: 'login',
            component: LoginComponent
        },
        {
            path: 'register',
            component: RegisterComponent
        },
        {
            path: 'unavailable',
            component: UnavailableComponent
        },
        {
            path: 'impressum',
            component: ImpressumComponent
        },
        {
            path: 'forgot-password',
            component: ForgotPasswordComponent
        },
    ]
  },
  { path: 'reservations', component: CardsManagementComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
